export const PLATFORM_NAME = 'webull'
export const PLATFORM_LOGO = '/webull-logo.png'
export const PLATFORM_FAVICON = '/favicon.png'
export const PLATFORM_THEME_COLOR = '#0066FF'
